import { DocumentsInputs } from 'interfaces'
import { configGenaral } from 'utils/configGeneral'

export const handleUploadPDF = (
	file: File,
	titleFile: string,
	descriptionFile: string,
	setDocumentUpload: (document: DocumentsInputs) => void,
	showToast: (title: string, message: string, type: string) => void
): void => {
	const fileSize = file.size
	const fileMb = fileSize / 1024 ** 2
	if (fileMb <= configGenaral.maxfileSizeMB) {
		const render = new FileReader()
		render.onload = e => {
			const uploadedObj = { file, url: e.target?.result as string }
			setDocumentUpload({
				description: descriptionFile,
				title: titleFile,
				size: Number(fileMb.toFixed(2)),
				pdf: uploadedObj.url,
				name_file: uploadedObj.file.name
			})
		}
		render.readAsDataURL(file)
	} else {
		showToast(
			'Error',
			`Please select a file less than ${configGenaral.maxfileSizeMB}MB.`,
			'error'
		)
	}
}
